window.addEventListener('load', () => {
    const footer = document.querySelector('footer');
    const menus = footer?.querySelectorAll('[data-menu-toggle]');
    if (!menus) return;

    menus.forEach((menu) => {
        const header = menu.querySelector('.menu-title');

        header.addEventListener('click', () => {
            if (window.innerWidth <= 575) {
                menu.classList.toggle('menu-open');

                menus.forEach(otherMenu => {
                    if (otherMenu !== menu) {
                        otherMenu.classList.remove('menu-open');
                    }
                })
            }
        })
    })
})